import { createSelector } from 'reselect'
import getInformationGiftSelect from 'modules/gift/redux/selectors/get-information'
import { GIFT_INFORMATION_FORM } from 'modules/gift/constants'

const isInformationValidGiftSelect = createSelector(
  getInformationGiftSelect,
  information => {
    return Object.keys(GIFT_INFORMATION_FORM).every(key => {
      const obj = GIFT_INFORMATION_FORM[key]
      const validator = obj.validator
      const isRequired = obj.isRequired
      const value = information[obj.key]
      if (validator && !validator(value)) {
        return false
      }

      if (isRequired && !value) {
        return false
      }

      return true
    })
  }
)

export default isInformationValidGiftSelect
